<template>
  <pie-chart
    v-if="gradeChart"
    key="gradeChart"
    :chart-data="gradeChart"
    :tooltips-callback-cfg="tooltipsCallbackCfg"
    :legendCfg="{
      position: 'right'
    }"
  ></pie-chart>
</template>
<script>
import PieChart from "@/components/Base/PieChart";
import { COLOR_OPTION_GRADE_LETTER } from "@/helpers/color-chart-config";
export default {
  name: "grade-chart-student",
  components: { PieChart },
  props: ["grade"],
  data() {
    return {
      tooltipsCallbackCfg: {
        title: {
          prefix: "Grade"
        },
        label: true,
        afterLabel: {
          subfix: "classes"
        }
      }
    };
  },
  computed: {
    gradeChart() {
      return this.generateGradeChart(this.grade);
    }
  },
  methods: {
    generateGradeChart(dataGrade) {
      if (!dataGrade) return null;

      const { labels, data } = dataGrade;
      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: labels.map(
              label => COLOR_OPTION_GRADE_LETTER[label]
            ),
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
